// extracted by mini-css-extract-plugin
module.exports = {"loadingMessageContainer":"HotelBlock_loadingMessageContainer__bbcWp","iconSync":"HotelBlock_iconSync__3w_6z","fa-spin":"HotelBlock_fa-spin__3u_Gw"};